import {Brick, registerBrick, BrickContext} from 'olympe';
import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import {DYNContent} from './dyn/DYNContent.jsx';

/**
 * A popup allowing the user to create a purchase request from scratch
 */
export default class ShowDescribeYourNeedsPopup extends Brick {
    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {Object} user
     * @param {*} userDefaults
     * @param {*} getMasterData
     * @param {*} getL3Category
     * @param {*} getMaterialType
     * @param {function()} forwardEvent
     * @param {function(string)} setJSON
     */
    update($, [user, userDefault, getMasterData, getL3Category, getPSLRequest, getMaterialType, getBaseUnit, getSupplier, getAddressFromPlant, getIncoterms, getAllIncoterms, mlGetL3Category, getAllL3Categories, getItemCodeDesc], [forwardEvent, setJSON]) {
        const popupId = 'popup017f2c5b2287c9930ec7';
        if (!document.getElementById(popupId)) {
            const head = document.body;
            const popup = document.createElement('div');
            popup.id = popupId;
            head.appendChild(popup);
        }

        ReactDOM.render((<ShowDescribeYourNeedsPopup.Component
            context={$}
            setJSON={setJSON}
            forwardEvent={forwardEvent}
            name={{label: user?.description, value: user?.id, email: user?.email}}
            userDefaults={userDefault}
            getMasterData={getMasterData}
            getPSLRequest={getPSLRequest}
            getL3Category={getL3Category}
            getMaterialType={getMaterialType}
            getBaseUnit={getBaseUnit}
            getSupplier={getSupplier}
            getAddressFromPlant={getAddressFromPlant}
            getIncoterms={getIncoterms}
            getAllIncoterms={getAllIncoterms}
            mlGetL3Category={mlGetL3Category}
            getAllL3Categories={getAllL3Categories}
            getItemCodeDesc={getItemCodeDesc}
        />), document.getElementById(popupId));
    }
}

ShowDescribeYourNeedsPopup.Component = (props) => {
    return (
        <DYNContent {...props}/>
    );
};

ShowDescribeYourNeedsPopup.Component.propTypes = {
    forwardEvent: PropTypes.func,
    setJSON: PropTypes.func,
    name: PropTypes.object,
    userDefaults: PropTypes.object,
    context: PropTypes.instanceOf(BrickContext).isRequired,
    getPSLRequest: PropTypes.object,
    getMasterData: PropTypes.object,
    getL3Category: PropTypes.object,
    getMaterialType: PropTypes.object,
    getBaseUnit: PropTypes.object,
    getSupplier: PropTypes.object,
    getAddressFromPlant: PropTypes.object,
    getIncoterms: PropTypes.object,
    getAllIncoterms: PropTypes.object,
    mlGetL3Category: PropTypes.object,
    getAllL3Categories: PropTypes.object,
    getItemCodeDesc: PropTypes.object,
};

registerBrick('017f2c5b2287c9930ec7', ShowDescribeYourNeedsPopup);
